import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fbd04ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "litigation-application-info local-main-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LitigationEdit = _resolveComponent("LitigationEdit")!
  const _component_ApplicationInfo = _resolveComponent("ApplicationInfo")!
  const _component_ContractArea = _resolveComponent("ContractArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LitigationEdit, {
      ref: "litigation-edit",
      mainData: _ctx.mainData,
      flow: _ctx.flow.data,
      next: _ctx.next,
      info: true,
      payload: { overdueRecordId: _ctx.currentOverdueRecordId, applyLitigationId: _ctx.applyLitigationId },
      disabled: true
    }, null, 8, ["mainData", "flow", "next", "payload"]),
    (_ctx.applyLitigationId)
      ? (_openBlock(), _createBlock(_component_ApplicationInfo, {
          key: 0,
          id: _ctx.applyLitigationId
        }, null, 8, ["id"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ContractArea, { value: _ctx.currentOverdueRecordId }, null, 8, ["value"])
  ]))
}